import { useLoginInfo } from 'hooks/useLoginInfo';
import { useState } from 'react';
import { loginutil } from 'util/loginutil';
import { useZstdHeader } from '../useZstdHeader';
import { BottomSpace } from './BottomSpace';
import { Divider } from './Divider';
import { MenuItem } from './MenuItem';
import { SubMenuCompliance } from './submenu/SubMenuCompliance';
import { SubMenuProdGuide } from './submenu/SubMenuProdGuide';
import useMenuUrl, { MenuItemWrap } from './useMenuUrl';

export const MainMenuEn = ({ onClose, onClickAiChatbot }: { onClose: () => void; onClickAiChatbot?: () => void }) => {
  const { getMenuUrl, menuEnabled } = useMenuUrl({ type: 'menu' });
  const [openSubMenu, setOpenSubMenu] = useState<'prodGuide' | 'compliance' | null>(null);

  const { isPartner, isPtnrUser } = useZstdHeader();
  const loginInfo = useLoginInfo();

  return (
    <>
      {onClickAiChatbot && (
        <MenuItemWrap
          menuId='ai-chatbot'
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();
            onClickAiChatbot();
          }}
          type='menu'
        />
      )}

      <Divider />
      <MenuItemWrap menuId='dlcenter' onClick={onClose} type='menu' />
      <MenuItemWrap menuId='knowledge' onClick={onClose} type='menu' />
      <MenuItemWrap menuId='sample' onClick={onClose} type='menu' />
      <MenuItemWrap menuId='qna' onClick={onClose} type='menu' />

      <Divider />
      <MenuItemWrap menuId='test-report' onClick={onClose} type='menu' />

      {(loginutil.iswels(loginInfo) || isPartner || isPtnrUser()) && (
        <MenuItemWrap menuId='partner' onClick={onClose} type='menu' />
      )}

      <Divider />

      {menuEnabled('asset-insight') && <MenuItemWrap menuId='asset-insight' onClick={onClose} type='menu' />}

      {menuEnabled('energy-simul') && <MenuItemWrap menuId='energy-simul' onClick={onClose} type='menu' />}

      {/* <MenuItemWrap menuId="remote" onClick={onClose} type="menu" /> */}
      <MenuItem
        label={getMenuUrl('prod-selector').label}
        onClick={() => setOpenSubMenu(prev => prev === 'prodGuide' ? null : 'prodGuide')}
        isSubMenu
        showSubMenu={openSubMenu === 'prodGuide'}
      />
      {openSubMenu === 'prodGuide' && <SubMenuProdGuide onClose={onClose} />}
      <Divider />
      <MenuItemWrap menuId='ls-electric-global' onClick={onClose} type='menu' />
      {/* <MenuItemWrap menuId="ls-electric-japan" onClick={onClose} />
      <MenuItemWrap menuId="ls-electric-china" onClick={onClose} />
      <MenuItemWrap menuId="ls-electric-korea" onClick={onClose} /> */}

      <Divider />
      <MenuItemWrap menuId='news-event' onClick={onClose} type='menu' />
      <MenuItem
        label={getMenuUrl('compliance-sustainability').label}
        onClick={() => setOpenSubMenu(prev => prev === 'compliance' ? null : 'compliance')}
        isSubMenu
        showSubMenu={openSubMenu === 'compliance'}
      />
      {openSubMenu === 'compliance' && <SubMenuCompliance onClose={onClose} />}
      {openSubMenu !== 'compliance' && <BottomSpace />}
      <div style={{ flex: 1 }}></div>
    </>
  );
};
